<div class="fade-in-shimmer d-flex">
    <div class="shimmer shine"></div>
</div>